import { Modal } from 'antd';
import React, { useCallback } from 'react';

import { CancelButton, ConfirmButton } from '../DefaultFormButton';
import {
  FooterStyled,
  InfoIconHeadDotStyled,
  InfoIconOuterContainerStyled,
  InfoIconStraightLineStyled,
} from './styled';
import { ISweetAlertAsModal } from './types';

const SweetAlertAsModal: React.FC<Partial<ISweetAlertAsModal>> = ({
  customClass,
  show,
  info,
  danger,
  warning,
  error,
  showCancel,
  confirmBtnText,
  confirmBtnBsStyle,
  cancelBtnText,
  title,
  onConfirm,
  onCancel,
  // focusConfirmBtn,
  children,
}) => {
  const IconComponent = useCallback(() => {
    if (info)
      return (
        <InfoIconOuterContainerStyled>
          <InfoIconStraightLineStyled />
          <InfoIconHeadDotStyled />
        </InfoIconOuterContainerStyled>
      );
    return (
      <InfoIconOuterContainerStyled>
        <InfoIconStraightLineStyled />
        <InfoIconHeadDotStyled />
      </InfoIconOuterContainerStyled>
    );
  }, [info, danger, warning, error]);
  return (
    <Modal
      wrapClassName='modal-sweet-alert-wrapper'
      footer={null}
      title={null}
      cancelButtonProps={{ style: { display: showCancel ? 'block' : 'none' } }}
      onCancel={onCancel}
      onOk={onConfirm}
      cancelText={cancelBtnText}
      okText={confirmBtnText}
      okButtonProps={{ style: confirmBtnBsStyle }}
      visible={show}
      className={`modal-sweet-alert ${customClass}`}>
      <div className='px-4'>
        <div className='p-4 flex justify-center items-center'>
          <IconComponent />
        </div>
        <div className='modal-sweet-alert-title'>{title}</div>
        {children}
        <FooterStyled>
          <ConfirmButton onClick={onConfirm} className='btn btn-lg btn-link' style={{}}>
            {confirmBtnText}
          </ConfirmButton>
          {cancelBtnText && (
            <CancelButton onClick={onCancel} color='#038fde'>
              {cancelBtnText}
            </CancelButton>
          )}
        </FooterStyled>
      </div>
    </Modal>
  );
};

export default SweetAlertAsModal;
